import React, { FunctionComponent } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { CKToast } from '../CKToast';
import { Toast } from '../../common/types';

export interface CKToastContainerProps {
  toasts: Toast[];
  onClose: (id: string) => void;
  onEnter: (id: string) => void;
  onLeave: (id: string) => void;
}

export const CKToastContainer: FunctionComponent<CKToastContainerProps> = ({
  toasts,
  onClose = () => {},
  onEnter = () => {},
  onLeave = () => {},
}) => {
  return (
    <div className="ck-toast-container">
      <div className="ck-toast-stack">
        <AnimatePresence>
          {toasts.map(toast => {
            return (
              <motion.div
                onMouseLeave={() => {
                  onLeave(toast.id);
                }}
                onMouseEnter={() => {
                  onEnter(toast.id);
                }}
                key={toast.id}
                initial={{ opacity: 0, scale: 0.3 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
                positionTransition
              >
                <CKToast
                  variant={toast.variant}
                  onClose={() => onClose(toast.id)}
                  heading={toast.heading}
                  icon={toast.icon}
                  description={toast.description}
                />
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};
